import { Inventory } from '.';
import { action } from '@play-co/replicant';
import { defineActions } from '../../utils';

export const inventoryActions = (
  Inventory: Pick<Inventory, 'ruleset' | 'modifiers' | 'getters'>,
) =>
  defineActions<Inventory>()({
    /**
     * Consume gems and give points by provided exchange rate
     */
    exchangeGemsToPoints: action((state, amount: number, api) => {
      const {
        getGemsToPointsExchangeRates,
        getCurrencyGrantEvent,
      } = Inventory.ruleset;

      // Make sure that we have this rate on server
      // Without this check clint could fake data and get point for free
      const rates = getGemsToPointsExchangeRates();
      const rate = rates.find(({ items }) => items === amount);
      if (!rate) throw new Error('Exchange rate not found');

      // How much point we're going to give to user?
      // Base item value + bonus
      const reward = rate.items + rate.bonus;

      // How many gems will be consumed
      const consume = rate.premium;

      // How many gems user have?
      const { getGems, getCurrencies } = Inventory.getters(state);
      const gems = getGems();

      // Is this enough to do exchange?
      if (gems < consume) throw new Error('Not enough gems for exchange');

      // Do exchange
      const now = api.date.now();
      const oldCurrencies = getCurrencies(now);
      const { consumeGems, addPoints } = Inventory.modifiers(state);
      consumeGems(consume);
      addPoints(reward);

      // Send CurrencyGrant event
      api.sendAnalyticsEvents([
        getCurrencyGrantEvent(
          {
            feature: 'currency_exchange',
            $subFeature: 'bPoints',
          },
          {
            old: oldCurrencies,
            new: getCurrencies(now),
          },
        ),
      ]);
    }),

    /**
     * Consume gems and give energy by provided exchange rate
     */
    exchangeGemsToEnergy: action((state, amount: number, api) => {
      // Make sure that we have this rate on server
      // Without this check clint could fake data and get point for free
      const {
        getGemsToEnergyExchangeRates,
        getCurrencyGrantEvent,
      } = Inventory.ruleset;
      const rates = getGemsToEnergyExchangeRates();
      const rate = rates.find(({ items }) => items === amount);
      if (!rate) throw new Error('Exchange rate not found');

      // How much energy we're going to give to user?
      // Base item value + bonus
      const reward = rate.items + rate.bonus;

      // How many gems will be consumed
      const consume = rate.premium;

      // How many gems user have?
      const { getGems, getCurrencies } = Inventory.getters(state);
      const gems = getGems();

      // Is this enough to do exchange?
      if (gems < consume) throw new Error('Not enough gems for exchange');

      // Do exchange
      const now = api.date.now();
      const oldCurrencies = getCurrencies(now);
      const { consumeGems, addEnergy } = Inventory.modifiers(state);
      consumeGems(consume);
      addEnergy(reward, now);

      // Send CurrencyGrant event
      api.sendAnalyticsEvents([
        getCurrencyGrantEvent(
          {
            feature: 'currency_exchange',
            $subFeature: 'energy',
          },
          {
            old: oldCurrencies,
            new: getCurrencies(now),
          },
        ),
      ]);
    }),
  });
